export default __webpack_public_path__ + "static/media/img-c-00-bg-egt.8c2ae232.jpg";